import * as React from 'react'

import { SchoolPage_school_address } from 'main/pages/School/gql'
import License from '../Basics/Provider/License'
import { LicenseInformationContainer } from './LicenseInformation.styles'
import ProgramType from './ProgramType'

interface IProps {
  address: SchoolPage_school_address | null
  programType: string | null
  licenseStatus: string | null
  licenseNumber: string | null
  externalLicenseUrl: string | null | undefined
  slug: string | null
}

export default function ProgramInfomation(props: IProps) {
  const { address, programType, licenseStatus, licenseNumber, externalLicenseUrl, slug } = props

  function validateInformation() {
    if ((licenseNumber && licenseStatus && programType) || address!.state === 'WA') {
      return (
        <React.Fragment>
          <ProgramType programType={programType} />
          <License
            licenseNumber={licenseNumber!}
            licenseStatus={licenseStatus}
            externalLicenseUrl={externalLicenseUrl}
            slug={slug}
          />
        </React.Fragment>
      )
    } else if (programType) {
      return <ProgramType programType={programType} />
    }
  }

  return <LicenseInformationContainer>{validateInformation()}</LicenseInformationContainer>
}
